import type { MapRef } from 'react-map-gl/mapbox';

import type { GeoPoint, MarketShape } from './types';

export const getBoundsFromShape = (shape: MarketShape): [[number, number], [number, number]] => {
  const points = shape.coordinates.flat();
  if (points.length === 0) {
    throw new Error('Invalid polygon coordinates');
  }

  const lngs = points.map((coord) => coord.lon);
  const lats = points.map((coord) => coord.lat);

  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ];
};

const wrapLongitude = (longitude: number) => ((((longitude + 180) % 360) + 360) % 360) - 180;

export const getShapeFromMap = (map: Pick<MapRef, 'getBounds'>): GeoPoint[] => {
  const bounds = map.getBounds();
  if (bounds === null) {
    throw new Error('Map bounds are not available');
  }
  const northWest = bounds.getNorthWest();
  const vertices = [
    { lon: wrapLongitude(northWest.lng), lat: northWest.lat },
    {
      lon: wrapLongitude(bounds.getNorthEast().lng),
      lat: bounds.getNorthEast().lat,
    },
    {
      lon: wrapLongitude(bounds.getSouthEast().lng),
      lat: bounds.getSouthEast().lat,
    },
    {
      lon: wrapLongitude(bounds.getSouthWest().lng),
      lat: bounds.getSouthWest().lat,
    },
    // The first and last points of a polygon must be identical
    { lon: wrapLongitude(northWest.lng), lat: northWest.lat },
  ];
  return vertices;
};
